import { Dialog, Transition } from "@headlessui/react"
import classNames from "classnames"
import { Fragment } from "react"
import PropTypes from "prop-types"
import Container from "./Container"
/* Relies on ./src/css/transitions.css for transition styles */

const Modal = ({
  ariaLabel,
  children,
  isOpen,
  initialFocus,
  modalSize = `sm`,
  onClose,
  onChange,
}) => {
  const handleClose = () => {
    if (onClose !== undefined) {
      onClose()
    } else {
      onChange(false)
    }
    // Works around issue where headlessui doesn’t remove overflow:hidden from
    // from the document element when a modal is open on initial page (e.g. when
    // a page includes the slug for the modal in the URL) and then closed
    document.documentElement.style.overflow = ``
    document.documentElement.style.paddingRight = ``
  }

  return (
    <Transition show={isOpen} as={Fragment}>
      <Dialog
        initialFocus={initialFocus}
        onClose={handleClose}
        className="fixed z-40 inset-0 overflow-y-auto"
      >
        <Transition.Child
          as={Fragment}
          enter="dialog-overlay-transition-enter"
          enterFrom="dialog-overlay-transition-enter-from"
          enterTo="dialog-overlay-transition-enter-to"
          leave="dialog-overlay-transition-leave"
          leaveFrom="digalog-overlay-transition-leave-from"
          leaveTo="dialog-overlay-transition-leave-to"
        >
          <Dialog.Overlay
            className={`bg-white/90 fixed inset-0 overflow-y-auto`}
          />
        </Transition.Child>

        {/*
         * Must use table and table-cell to vertically center modal
         * because when modal content is taller than screen, it can’t be
         * scrolled in IE11. Can replace w/ flex & align-items center when
         * IE11 is dropped.
         */}
        <div className={`w-full h-full table`}>
          <div className={`table-cell align-middle`}>
            <Transition.Child
              as={Fragment}
              enter="dialog-transition-enter"
              enterFrom="dialog-transition-enter-from"
              enterTo="dialog-transition-enter-to"
              leave="dialog-transition-leave"
              leaveFrom="digalog-transition-leave-from"
              leaveTo="dialog-transition-leave-to"
            >
              <Container width={modalSize}>
                <div
                  className={`${classNames({
                    "p-4": modalSize === `sm`,
                    "p-8": modalSize !== `sm`,
                    "lg:p-12": modalSize === `lg`,
                  })} bg-white shadow-lg relative rounded-2xl mx-auto my-10 outline-none`}
                  aria-label={ariaLabel}
                  data-analytics-region="Modal"
                >
                  <button
                    aria-label="Close"
                    className={`bottom-full right-0 mb-1 shadow-lg bg-white hover:bg-gray-200 ${
                      modalSize === `sm`
                        ? ``
                        : `md:bottom-auto md:mb-0 md:top-0 md:mt-2 md:mr-2 md:bg-gray-200 md:hover:bg-gray-300 md:shadow-none`
                    } absolute text-gray-600 border border-gray-300 rounded-full w-6 h-6 duration-150 transition-colors focus:outline-none focus:ring`}
                    onClick={(event) => {
                      handleClose()
                      event.preventDefault()
                    }}
                  >
                    <i
                      className={`icon-x absolute left-1/2 top-1/2 -legacy-translate-1/2`}
                      aria-hidden
                    ></i>
                  </button>
                  {children}
                </div>
              </Container>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  )
}

export default Modal

Modal.propTypes = {
  children: PropTypes.node,
  isOpen: PropTypes.bool,
  initialFocus: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.any }),
  ]),
  onClose: PropTypes.func,
  onChange: PropTypes.func,
}
